import { FaChevronDown } from 'react-icons/fa';
import React, { useEffect, useState, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import axios from 'axios'
import { MdChecklist } from "react-icons/md"

const TemplateChecklist = () => {
    const axiosPrivate = useAxiosPrivate()
    const [checklist, setChecklist] = useState({})
    const location = useLocation()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        let isMounted = true
        const controller = new AbortController()

        const fetchData = async () => {
            setIsLoading(true)
            try {
                const templateResponse = await axiosPrivate.get(
                    'template/retrieve-checklist',
                    {
                        signal: controller.signal,
                    },
                )

                if (isMounted) {
                    setChecklist(templateResponse.data)
                }
            } catch (err) {
                if (axios.isCancel(err)) {
                    // Log for debugging purposes
                    // console.log('Request cancelled:', err.message);
                } else {
                    console.error('Request failed:', err)
                    // Only navigate if the error was not a cancellation
                    // Check for a 403 status code specifically
                    if (err.response && err.response.status === 403) {
                        navigate('/sign-in', { state: { from: location }, replace: true })
                    }
                }
            }

            setIsLoading(false)
        }

        fetchData()

        return () => {
            isMounted = false
            controller.abort()
            // console.log('Cleanup: Cancelled any ongoing requests.');
        }
    }, [navigate, location, axiosPrivate])

    if (isLoading) {
        return <div>Loading...</div> // Or any loading spinner
    }
    return (
        <div className="p-6 md:p-10 max-w-6xl w-full mx-auto">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary text-primary-foreground">
          <MdChecklist className="w-5 h-5" />
        </div>
        <div>
          <h1 className="text-2xl font-display font-bold text-foreground">
            Category Checklist Overview
          </h1>
          <p className="text-sm text-muted-foreground">{checklist.month}</p>
        </div>
      </div>

      <div className="space-y-3 pb-10">
                {Object.entries(checklist.data || {}).map(([scope, items]) => (
                        <details key={scope} open className="group rounded-lg border bg-card overflow-hidden">
                            <summary className="w-full flex justify-between items-center p-4 hover:bg-accent/50 transition-colors cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                                <h4 className="font-display font-semibold text-sm text-card-foreground">
                                    {scope} Categories
                                </h4>
                                <FaChevronDown className="w-4 h-4 text-muted-foreground transition-transform duration-200 group-open:rotate-180" />
                            </summary>
                            <div className="px-4 pb-3 space-y-1">
                                {items.map((item) => (
                                    <div
                                        key={item.id}
                                        className="flex justify-between items-center py-2 px-2 rounded-md hover:bg-accent/30 transition-colors"
                                    >
                                        {/* Category name on the left */}
                                        <span className="text-sm text-foreground">{item.name}</span>

                                        {/* Count + Checkbox on the right */}
                                        <div className="flex items-center gap-3">
                                            <span className="text-xs text-muted-foreground">
                                                {item.count} entr{item.count === 1 ? "y" : "ies"}
                                            </span>
                                            <input
                                                type="checkbox"
                                                checked={item.count > 0}
                                                className="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                ))}
                            </div>
                        </details>
                ))}
            </div>
        </div>
    );

};

export default TemplateChecklist;
